import { Grid } from '@mui/material';
import { HSpacer, RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';

import InfoIconRed from '../../../assets/img/info-icon-red.svg';
import { intl } from '../../../helpers/IntGlobalProvider';
import Button from '../../../react-components/Button';
import Text from '../../../react-components/Text';
import { intercom } from '../../../services/intercom';
import { FieldDefinition } from '../fields/FieldDefinitions';
import { FieldMapping } from '../fields/FieldMapping';
import { MapFieldsColumn } from './MapFieldsColumn';

export const MapFields = ({
  mapping,
  headers,
  dataLength,
  fields,
  addressFields,
  continueIntlId,
  setMapping,
  onCompleted,
  onBack,
}: {
  mapping: FieldMapping;
  headers: string[];
  dataLength: number;
  fields: FieldDefinition[];
  addressFields?: FieldDefinition[];
  continueIntlId?: string;
  setMapping: (mapping: FieldMapping) => void;
  onCompleted: (mappedData: FieldMapping) => void;
  onBack: () => void;
}) => {
  return (
    <Grid container direction="column" wrap="nowrap" style={{ height: `calc(80vh - 52px)` }}>
      <Grid container direction="row" justifyContent="space-between" wrap="nowrap">
        <Grid item container direction="row">
          <Text intlId="data_importer_dialog.map_fields.rows" intlValues={{ rows: dataLength }} />
          <HSpacer small />
          <Text intlId="data_importer_dialog.map_fields.columns" intlValues={{ columns: headers.length }} />
          <HSpacer small />
          <Text
            intlId="data_importer_dialog.map_fields.mapped_fields"
            intlValues={{ fields: mapping.getItems().length }}
          />
        </Grid>
      </Grid>

      <VSpacer medium />

      <Grid
        container
        direction="column"
        wrap="nowrap"
        style={{
          height: `calc(100% - 80px)`,
          border: `1px solid ${RoutalPalette.grey4}`,
          borderRadius: `10px`,
          padding: `20px`,
          overflow: `auto`,
        }}
      >
        {headers.map((header, headerIndex) => (
          <MapFieldsColumn
            key={headerIndex}
            columnName={header}
            columnIndex={headerIndex}
            isLastColumn={headerIndex === headers.length - 1}
            mapping={mapping}
            fields={fields}
            addressFields={addressFields}
            setMapping={setMapping}
          />
        ))}
      </Grid>

      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="nowrap"
        style={{ height: `80px` }}
      >
        <Button
          variant="flat"
          styleType="secondary"
          style={{ minWidth: `80px` }}
          onClick={() => onBack()}
          intlId="back"
        />

        <Grid
          item
          container
          direction="row"
          justifyContent="flex-end"
          flexWrap="nowrap"
          padding={`0px 10px`}
          style={{ width: `unset` }}
        >
          {addressFields && mapping.hasAnyAddressField() ? (
            <>
              {mapping.hasValidAddress() ? (
                <>
                  <Text style={{ color: RoutalPalette.primary40 }}>
                    {`${intl.formatMessage({
                      id: `data_importer_dialog.map_fields.location_mapping_example`,
                    })}:`}
                  </Text>

                  <HSpacer small />

                  <Text>{mapping.getAddresses().slice(0, 1)}</Text>
                </>
              ) : (
                <>
                  <Text
                    style={{ color: RoutalPalette.error.medium }}
                    intlId="data_importer_dialog.map_fields.location_mapping_example.invalid"
                  />

                  <HSpacer small />

                  <img
                    style={{ cursor: `pointer` }}
                    onClick={() => intercom.open()}
                    alt=""
                    src={InfoIconRed}
                    width="16px"
                    draggable="false"
                  />
                </>
              )}
            </>
          ) : null}
        </Grid>

        <Button
          intlId={continueIntlId ?? `continue`}
          style={{ minWidth: `80px` }}
          onClick={() => {
            onCompleted(mapping);
          }}
        />
      </Grid>
    </Grid>
  );
};
